export default {
	"title": "サポートが必要です",
	"image": "スクリーンショット",
	"email": "Email",
	"name": "上传",
	"placeholder": "あなたは、あなたの問題を説明したり、ここで私たちとあなたのアイデアを共有することができます",
	"desc": "あなたのフィードバックはできるだけ早く対処されます。",
	"submit": "送信",
}
